function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1165-684H755v4055h-1920z"
}), React.createElement("path", {
  d: "M-1165-351H755v3657h-1920z"
}), React.createElement("g", {
  transform: "translate(-70 -52)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M125.543 99.025 113.685 63.88a.937.937 0 0 0-1.776 0l-5.63 16.685c-2.409-2.856-6.008-4.676-10.029-4.676-7.237 0-13.125 5.887-13.125 13.125 0 6.92 5.388 12.593 12.188 13.077v7.548a.937.937 0 1 0 1.874 0v-7.548a13.027 13.027 0 0 0 5.789-1.827h9.212v9.375a.937.937 0 1 0 1.874 0v-9.375h10.593a.937.937 0 0 0 .888-1.238zM97.187 96.9l2.538-2.538a.936.936 0 1 0-1.325-1.326l-2.15 2.15-2.15-2.15a.936.936 0 1 0-1.325 1.326l2.537 2.538v3.314C89.547 99.734 85 94.898 85 89.012c0-6.204 5.047-11.25 11.25-11.25 4.087 0 7.66 2.197 9.63 5.465a11.424 11.424 0 0 1 1.332 3.29 11.26 11.26 0 0 1 .288 2.495c0 .442-.033.88-.083 1.312-.016.14-.043.275-.063.412a11.191 11.191 0 0 1-.286 1.331c-.077.272-.167.54-.264.804-.051.141-.097.285-.154.422-.154.374-.326.74-.52 1.094-.06.11-.13.212-.194.32-.153.259-.313.515-.487.761a9.62 9.62 0 0 1-.276.368c-.184.239-.377.472-.581.697-.08.088-.157.178-.24.263a11.427 11.427 0 0 1-2.092 1.71 11.16 11.16 0 0 1-5.073 1.709V96.9zm16.876 1.487V96.9l2.537-2.538a.936.936 0 1 0-1.325-1.326l-2.15 2.15-2.15-2.15a.936.936 0 1 0-1.325 1.326l2.537 2.538v1.487h-6.762l.04-.043c.162-.159.31-.33.463-.497.145-.159.296-.312.433-.476.054-.066.102-.137.155-.204a12.997 12.997 0 0 0 2.776-6.722c.004-.032.012-.062.015-.094.045-.441.067-.888.067-1.338a13.098 13.098 0 0 0-.092-1.495c-.041-.356-.092-.71-.162-1.06-.025-.13-.06-.254-.09-.382a13.466 13.466 0 0 0-.327-1.18c-.064-.191-.136-.38-.208-.569a13.279 13.279 0 0 0-.85-1.8l-.03-.057 5.18-15.357 10.554 31.276h-9.286v-.002z"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 93.64,
  y: 138.719
}, "Las")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/las.ccf98ddd.svg";
export { SvgComponent as ReactComponent };